module.exports = __webpack_public_path__ + "static/img/New.46597729.png";